"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateRange = exports.getOpenDays = void 0;
var moment = require("moment");
var getOpenDays = function (weekDays, selectedUsers) {
    return weekDays.map(function (weekDay) {
        if (weekDay.user && selectedUsers.indexOf(weekDay.user._id) > -1) {
            return weekDay.workDays.filter(function (workDay) {
                return !workDay.is_closed;
            });
        }
        return [];
    }).filter(function (day) { return !!day && day.length; });
};
exports.getOpenDays = getOpenDays;
var getDateRange = function (dateFrom, dateTo, increment) {
    if (increment === void 0) { increment = 1; }
    var dateFromObj = moment(dateFrom).startOf('day');
    var dateToObj = moment(dateTo).endOf('day');
    var dateRange = [];
    for (var day = moment(dateFromObj); day.isBefore(dateToObj); day.add(increment, 'day')) {
        dateRange.push(day.format('YYYY-MM-DD'));
    }
    return dateRange;
};
exports.getDateRange = getDateRange;
